module.exports = __webpack_public_path__ + "img/1.e8dbd9ae.png";